import React, { useState } from "react";
import {
  DataGrid,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import classes from "./RulesPage.module.css";

export const DEFAULT_COLUMNS = [
  {
    field: "ruleName",
    headerName: "Rule name",
    flex: 1,
    minWidth: 160,
    valueGetter: ({ row }) => row?.ruleName || row?.flagName || row?.ruleFlag || row?.name || row?.type || "",
  },
  {
    field: "valueText",
    headerName: "Value",
    flex: 0.6,
    minWidth: 100,
    valueGetter: ({ row }) =>
      row?.valueText ??
      row?.value ??
      row?.threshold ??
      row?.ruleValue ??
      row?.ruleThreshold ??
      row?.thresholdValue ??
      row?.amount ??
      "",
  },
  {
    field: "changedBy",
    headerName: "Changed by",
    flex: 0.8,
    minWidth: 140,
    valueGetter: ({ row }) => row?.changedBy || row?.setBy || row?.updatedBy || row?.modifiedBy || "",
  },
  {
    field: "changedDate",
    headerName: "Changed date",
    flex: 0.8,
    minWidth: 140,
    valueGetter: ({ row }) => row?.changedDate || row?.setDate || row?.updatedDate || row?.modifiedDate || "",
  },
];

const GenericRuleLogTable = ({
  rows = [],
  columns = DEFAULT_COLUMNS,
  loading = false,
  paginationMode = "client",
  page = 0,
  pageCount = 0,
  rowCount = 0,
  pageSize: initialPageSize = 10,
  onPageChange,
}) => {
  const [pageSize, setPageSize] = useState(initialPageSize);

  React.useEffect(() => {
    setPageSize(initialPageSize);
  }, [initialPageSize]);

  const CustomPagination = () => {
    const apiRef = useGridApiContext();
    const currentPage = useGridSelector(apiRef, gridPageSelector);
    const currentPageCount = useGridSelector(apiRef, gridPageCountSelector);

    if (paginationMode === "server") {
      return (
        <Pagination
          color="primary"
          count={currentPageCount}
          page={currentPage + 1}
          onChange={(_, value) => onPageChange?.(value - 1)}
        />
      );
    }

    return (
      <Pagination
        color="primary"
        count={currentPageCount}
        page={currentPage + 1}
        onChange={(_, value) => apiRef.current.setPage(value - 1)}
      />
    );
  };

  return (
    <div className={classes.logCard}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.seqId ?? row.id}
        autoHeight
        pagination
        paginationMode={paginationMode}
        page={paginationMode === "server" ? page : undefined}
        onPageChange={paginationMode === "server" ? onPageChange : undefined}
        rowCount={paginationMode === "server" ? rowCount : undefined}
        pageSize={pageSize}
        onPageSizeChange={paginationMode === "server" ? undefined : (size) => setPageSize(size)}
        rowsPerPageOptions={paginationMode === "server" ? [10] : [5, 10, 25, 50]}
        disableRowSelectionOnClick
        loading={loading}
        hideFooterSelectedRowCount
        components={{ Pagination: CustomPagination }}
      />
    </div>
  );
};

export default GenericRuleLogTable;
